import React from 'react';
import { motion } from 'framer-motion';
import styles from '../pages/Legal/Legal.module.css';

const AffiliatePolicy = () => {
  return (
    <div className={styles.legalPage}>
      <div className={styles.dotPattern} />
      <div className={styles.glowOrb1} />
      <div className={styles.glowOrb2} />
      
      <motion.div 
        className={styles.container}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <header className={styles.header}>
          <h1 className={styles.title}>Affiliate Program Policy</h1>
          <p className={styles.subtitle}>Join our affiliate program and earn a 30% commission for every successful referral. Learn about our terms, conditions, and benefits.</p>
        </header>

        <div className={styles.content}>
          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>Program Overview</h2>
            <p className={styles.text}>
              Welcome to the ReverBeat Affiliate Program! Our program offers a generous 30% commission on all successful referral purchases. 
              We've designed this program to reward our community members who help spread the word about our AI-powered audio processing tools.
            </p>

            <div className={styles.highlight}>
              <h3 className={styles.highlightTitle}>Commission Structure</h3>
              <ul className={styles.list}>
                <li className={styles.listItem}>Base Commission Rate: 30% per sale</li>
                <li className={styles.listItem}>Commission Duration: Lifetime of the referred customer</li>
                <li className={styles.listItem}>Payment Threshold: $50</li>
                <li className={styles.listItem}>Payment Schedule: Monthly</li>
              </ul>
            </div>

            <h2 className={styles.sectionTitle}>Eligibility Requirements</h2>
            <ul className={styles.list}>
              <li className={styles.listItem}>Must be at least 18 years old</li>
              <li className={styles.listItem}>Have a valid payment method for receiving commissions</li>
              <li className={styles.listItem}>Maintain an active ReverBeat account in good standing</li>
              <li className={styles.listItem}>Comply with all terms and conditions of the affiliate agreement</li>
            </ul>

            <h2 className={styles.sectionTitle}>Promotional Guidelines</h2>
            <ul className={styles.list}>
              <li className={styles.listItem}>Use only approved marketing materials and accurate product descriptions</li>
              <li className={styles.listItem}>No spam, misleading advertising, or false promises</li>
              <li className={styles.listItem}>Clear disclosure of affiliate relationship in promotions</li>
              <li className={styles.listItem}>No bidding on ReverBeat branded terms in paid advertising</li>
            </ul>

            <h2 className={styles.sectionTitle}>Commission Tracking</h2>
            <p className={styles.text}>Our advanced tracking system ensures accurate attribution of sales through:</p>
            <ul className={styles.list}>
              <li className={styles.listItem}>Unique referral links for each affiliate</li>
              <li className={styles.listItem}>30-day cookie duration</li>
              <li className={styles.listItem}>Real-time sales tracking dashboard</li>
              <li className={styles.listItem}>Detailed performance analytics</li>
            </ul>

            <h2 className={styles.sectionTitle}>Payment Terms</h2>
            <ul className={styles.list}>
              <li className={styles.listItem}>Payments processed monthly for balances exceeding $50</li>
              <li className={styles.listItem}>Multiple payment methods supported (PayPal, Bank Transfer)</li>
              <li className={styles.listItem}>60-day holding period for commission validation</li>
              <li className={styles.listItem}>Commissions void on refunded purchases</li>
            </ul>

            <h2 className={styles.sectionTitle}>Program Benefits</h2>
            <ul className={styles.list}>
              <li className={styles.listItem}>Access to exclusive promotional materials</li>
              <li className={styles.listItem}>Real-time performance tracking dashboard</li>
              <li className={styles.listItem}>Dedicated affiliate support team</li>
              <li className={styles.listItem}>Regular promotional opportunities and bonus campaigns</li>
            </ul>

            <h2 className={styles.sectionTitle}>Terms and Termination</h2>
            <p className={styles.text}>
              ReverBeat reserves the right to modify program terms or terminate affiliate relationships for policy violations. 
              Changes to the program will be communicated with 30 days notice.
            </p>
          </section>
        </div>

        <div className={styles.contact}>
          <h2 className={styles.contactTitle}>Ready to Join?</h2>
          <p className={styles.contactText}>Start earning commissions by becoming a ReverBeat affiliate today.</p>
          <a href="/affiliate-dashboard" className={styles.contactLink}>Join Affiliate Program</a>
        </div>
      </motion.div>
    </div>
  );
};

export default AffiliatePolicy;
